module.exports = __webpack_public_path__ + "img/tmdb-logo.02a9430b.svg";